import React, { FC, useState } from 'react';

// components
import { Descendant } from 'slate';

import WrapTextToggle from '../../../components/shared/WrapTextToggle/WrapTextToggle';
import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';

// model
import { MaxCharacterModel } from '../../../models/formula.model';

import FormulaAlternateMain from '../../../views/formulaCreate/formulaAlternate/FormulaAlternateMain';

interface AlternateListPreviewProps {
    formulaStructure: Descendant[];
    extraPlaceholderCharacters: MaxCharacterModel;
    formulaId: number;
    isEditable: boolean;
    wrapText?: boolean;
    onWrapTextChange?: (enabled: boolean) => void;
}

const AlternateListPreview: FC<
    React.PropsWithChildren<AlternateListPreviewProps>
> = ({
    formulaStructure,
    formulaId,
    isEditable,
    wrapText: wrapTextProp,
    onWrapTextChange,
}) => {
    const [wrapTextInternal, setWrapTextInternal] = useState(false);
    const isControlled = wrapTextProp !== undefined;
    const wrapText = isControlled ? wrapTextProp! : wrapTextInternal;
    const setWrapText = isControlled
        ? (v: boolean) => onWrapTextChange?.(v)
        : setWrapTextInternal;

    return (
        <Wrapper>
            {!isControlled && (
                <ToggleRow>
                    <WrapTextToggle
                        isEnabled={wrapText}
                        onChange={setWrapText}
                    />
                </ToggleRow>
            )}
            <Container>
                <FormulaAlternateMain
                    formulaId={formulaId}
                    isEditable={isEditable}
                    formulaStructure={formulaStructure}
                    wrapText={wrapText}
                />
            </Container>
        </Wrapper>
    );
};

const Wrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});

const ToggleRow = styled.div({
    display: 'flex',
    justifyContent: 'flex-end',
    padding: aampeTheme.spacing4(1, 0),
});

const Container = styled.div({
    display: 'flex',
    width: '100%',
    overflow: 'auto',
});

export default AlternateListPreview;
